(function() {
  function isSheetsCell(node) {
    if (!node || node.nodeType !== 1) {
      return false;
    }
    if (node.classList && node.classList.contains('cell-input')) {
      return true;
    }
    if (node.className && String(node.className).indexOf('cell-input') !== -1) {
      return true;
    }
    if (node.hasAttribute('aria-autocomplete')) {
      return true;
    }
    var label = node.getAttribute('aria-label');
    if (label && /^I\d+$/.test(label)) {
      return true;
    }
    return false;
  }

  function unwrapToParagraph(node) {
    var paragraph = document.createElement('p');
    while (node.firstChild) {
      paragraph.appendChild(node.firstChild);
    }
    var text = paragraph.textContent ? paragraph.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!text) {
      node.remove();
      return;
    }
    node.replaceWith(paragraph);
  }

  function cleanupContainer(container) {
    if (!container) {
      return;
    }
    container.querySelectorAll('.cell-input, [class*="cell-input"], div[aria-autocomplete], div[aria-label]').forEach(function(node) {
      if (!isSheetsCell(node)) {
        return;
      }
      unwrapToParagraph(node);
    });
    container.querySelectorAll('div[dir="ltr"], div[dir=\'ltr\']').forEach(function(node) {
      if (!container.contains(node)) {
        return;
      }
      if (node.children.length === 0 && !(node.textContent || '').trim()) {
        node.remove();
      }
    });
  }

  function runCleanup() {
    document.querySelectorAll('.main-description, .enhanced-description').forEach(cleanupContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCleanup);
  } else {
    runCleanup();
  }
  window.addEventListener('load', runCleanup);
  [100, 500, 2000, 5000].forEach(function(ms) {
    window.setTimeout(runCleanup, ms);
  });
})();
